import { useEffect, useState } from 'react';
import './App.css';
import pinkmomentimage from './assets/pinkMoment.jpeg'

import AboutText from './components/AboutText';
import Clock from './components/clock';
import Timer from './components/timer';
import ShareButton from './components/shareButton';

import { helperFunctions } from './helperfunctions';

function App() {
  const [clockTime, setclockTime] = useState("eshtablishing a link")
  const [countDown, setCountDown] = useState("^<>")

  function updateClock() {
    helperFunctions.getSunsetTime().then(sunsetTime => {
      const MS_PER_MINUTE = 60000;
    
      // 4 minutes AFTER sunset
      const pinkMomentTime = new Date(sunsetTime.getTime() + 4 * MS_PER_MINUTE);
    
      setclockTime(helperFunctions.dateToString(pinkMomentTime));
    
      const timeleft = helperFunctions.calculateTimeLeft(pinkMomentTime);
      setCountDown(`${timeleft.hours} hours and ${timeleft.minutes - timeleft.hours * 60} minutes`);
    
      setInterval(() => {
        const timeleft = helperFunctions.calculateTimeLeft(pinkMomentTime);
        setCountDown(`${timeleft.hours} hours and ${timeleft.minutes - timeleft.hours * 60} minutes`);
      }, 60000);
    });
}

useEffect(() => {
    updateClock()
  },[]);

  return (
    <div className="body">
      <p className="time-left-wrapper">if visible...<br/>
Today's Pink Moment will begin at approximately</p >
      <Clock clockTime={clockTime}/>
      {/* <Timer countDown={countDown}/> */}
      <ShareButton/>
      <AboutText/>
    </div>
  );
}

export default App;
